import { Box, Container } from "@chakra-ui/react";
import { Text } from "@chakra-ui/react";
import "@fontsource/barlow-condensed/100.css";

interface LogoProps {
  size: string;
  tagLineIndex?: number;
  isBanner?: boolean;
  fontWeight?: string;
}

const Logo: React.FC<LogoProps> = ({
  size = "8xl",
  tagLineIndex = 0,
  isBanner = false,
  fontWeight = "300",
}: LogoProps) => {
  const getLogoStyles = () => {
    const properties = {
      fontFamily: "Barlow Condensed",
      size,
      letterSpacing: "-0.1em",
    };
    return properties;
  };

  const styles = getLogoStyles();
  const taglines = [
    "engage with your audience",
    "Insights for Creators",
    "Build a better product",
    "Make a difference",
  ];

  return (
    <Box display="ruby">
      <Container
        display="flex"
        letterSpacing={styles.letterSpacing}
        fontFamily={styles.fontFamily}
        fontSize={styles.size}
        fontWeight={fontWeight}
        ps="0"
      >
        <Text color="red.500">Q</Text>
        <Text color="yellow.300">i</Text>
        <Text color="blue.500">Q</Text>
      </Container>
      {isBanner && (
        <Text
          opacity="opacity.40"
          fontSize={"xl"}
          color="gray.400"
          alignSelf="center"
        >
          {taglines[tagLineIndex]}
        </Text>
      )}
    </Box>
  );
};

export default Logo;
